import { useJwtToken } from "@website/hooks/auth-manager";
import { useViewPort } from "@website/hooks/viewport";
import { useLoginModal } from "@website/widget/login";
import { useRouter } from "next/router";
import { useCallback, useEffect, useState } from "react";

const UseReverseBookingModal = () => {
  const router = useRouter();
  const { onLoginModalOpen } = useLoginModal();
  const { isDesktop } = useViewPort();
  const { phoneNumber } = useJwtToken();
  const [isReservePageOpen, setIsReservePageOpen] = useState(false);

  const onModalClose = useCallback(() => setIsReservePageOpen(false), []);
  const onModalOpen = useCallback(() => {
    setIsReservePageOpen(true);
    if (
      !phoneNumber &&
      router?.query?.["date_from"] &&
      router?.query?.["date_to"]
    )
      return onLoginModalOpen().then(() => setIsReservePageOpen(true));
  }, [phoneNumber, router]);

  useEffect(() => {
    setIsReservePageOpen(false);
  }, [isDesktop]);
  return {
    isReservePageOpen,
    onModalClose,
    onModalOpen
  };
};

export default UseReverseBookingModal;
